.gh-portal-account-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 0 32px;
}

.gh-portal-account-header .gh-portal-avatar {
    margin: 6px 0 8px !important;
}

.gh-portal-account-data {
    margin-bottom: 40px;
}

footer.gh-portal-account-footer {
    display: flex;
}

.gh-portal-account-footer.paid {
    margin-top: 12px;
}

.gh-portal-account-footermenu {
    display: flex;
    align-items: center;
    list-style: none;
    padding: 0;
    margin: 0;
}

.gh-portal-account-footerright {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: flex-end;
}

.gh-portal-account-footermenu li {
    margin-inline-end: 16px;
}

.gh-portal-account-footermenu li:last-of-type {
    margin-inline-end: 0;
}

.gh-portal-freeaccount-newsletter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
}

.gh-portal-freeaccount-newsletter .label {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.gh-portal-free-ctatext {
    margin-top: -12px;
}

.gh-portal-cancelcontinue-container {
    margin: 24px 0 32px;
}

.gh-portal-cancel-banner {
    position: relative;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    text-align: center;
    font-size: 1.4rem;
    line-height: 1.5;
    color: var(--grey1);
}

.gh-portal-cancel-banner::before {
    position: absolute;
    content: "";
    display: block;
    background: var(--brandcolor);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 8px;
    opacity: 0.05;
    pointer-events: none;
    z-index: 0;
}

.gh-portal-cancel-banner > * {
    position: relative;
    z-index: 1;
}

.gh-portal-cancel-banner p {
    max-width: 320px;
    margin: 0 auto 16px;
}

.gh-portal-canceled-badge {
    display: inline-block;
    margin-inline-start: 6px;
    padding: 6px 8px;
    font-size: 1.1rem;
    line-height: 1em;
    font-weight: 600;
    letter-spacing: 0.05px;
    text-transform: uppercase;
    color: var(--grey6);
    background: color-mix(in srgb, var(--grey12) 60%, transparent);
    border-radius: 32px;
    vertical-align: middle;
    position: relative;
    top: -1px;
}

.gh-portal-list-detail .gh-portal-email-notice {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;
    color: var(--red);
    font-weight: 500;
    font-size: 1.25rem;
    letter-spacing: 0.2px;
}

.gh-portal-email-notice-icon {
    width: 20px;
    height: 20px;
}

.gh-portal-billing-button-loader {
    width: 32px;
    height: 32px;
    margin-inline-end: -3px;
    opacity: 0.6;
}

.gh-portal-product-icon {
    width: 52px;
    margin-inline-end: 12px;
    border-radius: 2px;
}

.gh-portal-account-discountcontainer {
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.gh-portal-account-expiry {
    white-space: nowrap;
}

.gh-portal-account-expiry-separator {
    margin: 0 4px;
}

@media (max-width: 480px) {
    .gh-portal-account-expiry-separator {
        display: none;
    }

    .gh-portal-account-expiry {
        flex-basis: 100%;
    }
}

.gh-portal-account-old-price {
    text-decoration: line-through;
    color: var(--grey9) !important;
}

.gh-portal-account-tagicon {
    width: 16px;
    height: 16px;
    color: var(--brandcolor);
    margin-inline-end: 4px;
    z-index: 999;
}

@media (max-width: 390px) {
    .gh-portal-account-footer {
        padding: 0 !important;
    }
}

@media (max-width: 340px) {
    .gh-portal-account-footer {
        padding: 0 !important;
        flex-wrap: wrap;
        gap: 12px;
    }

    .gh-portal-account-footer .gh-portal-account-footerright {
        justify-content: flex-start;
    }
}
